<template>
  <div class="header__notification header__drodown-parent">
    <a href="#">
      <i class="fab fa-weixin"></i>
      <span v-if="unread_messages_count">
        <i>{{unread_messages_count}}</i>
      </span>
    </a>
    <div class="header__dropdown ps-block--header-messages">
      <div class="ps-block__header">
        <i class="fa fa-sliders"></i>
      </div>
      <div class="ps-block__content">
        <div v-for="(message,index) in messages" :key="index" class="ps-block--message">
          <div class="ps-block__thumbnail">
            <img :src="message.sender.mid_avatar" alt />
          </div>
          <div class="ps-block__content">
            <a :href="message.sender.url">
              <span class="success"></span>
              {{message.sender.name}}
            </a>
            <a :href="message.url">
              <i class="fa fa-comment-o"></i>
              {{message.content.substring(0,50)}}
            </a>
            <i>
              <local-time :time="message.created_at"></local-time>
            </i>
          </div>
        </div>
      </div>
      <div class="ps-block__footer text-center">
        <a href="/dashboard/message">
          <span class="ps-icon--dots">
            <i></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LocalTime from "./../../../LocalTime";
export default {
  name: "message-notification",
  components: {
    LocalTime
  },
  props: ["user"],
  data() {
    return {
      User: null,
      messages: [],
      unread_messages_count: 0
    };
  },
  mounted() {
    let self = this;
    self.getUnreadMessagesCount();
    self.getLastUnreadMessages();
    self.User = JSON.parse(this.user);
    Echo.private("message-notification." + this.User.id).listen(
      "MessageSent",
      event => {
        self.getLastUnreadMessages();
        self.getUnreadMessagesCount();
      }
    );
  },

  methods: {
    getLastUnreadMessages: function() {
      let self = this;
      axios({
        method: "get",
        url:
          "/api/v1/message/get-latest-unread-messages/" +
          window.user_id +
          "/5?api_token=" +
          window.api_token
      })
        .then(function(response) {
          //console.log(response.data);
          self.messages = response.data.data;
        })
        .catch(function(err) {
          let errors = err.response.data.errors;
          //console.log(errors);
        });
    },
    getUnreadMessagesCount: function() {
      let self = this;
      axios({
        method: "get",
        url:
          "/api/v1/message/get-number-of-unread-messages?api_token=" +
          window.api_token
      })
        .then(function(response) {
          //console.log(response.data);
          self.unread_messages_count = response.data.data;
        })
        .catch(function(err) {
          let errors = err.response.data.errors;
          //console.log(errors);
        });
    }
  }
};
</script>
